import { Container } from '@chakra-ui/react';
import { Input } from 'components/Input';
import { Visible } from 'components/Visible';
import { useEffect, useState } from 'react';
import { Calendar } from 'react-date-range';
import { DateRangeState } from 'utils';

import './datePicker.css';

type DatePickerProps = {
    placeholder: string;
    onChange: (dates: DateRangeState) => void;
    tabChanged: boolean;
}
const DatePicker = ({placeholder, onChange, tabChanged}: DatePickerProps) => {
    const [dateRangeVisible, setDateRangeVisible] = useState(false);
    const [datesSelected, setDatesSelected] = useState<Date>()
 
    useEffect(() => {
        setDateRangeVisible(false);
    }, [tabChanged])
    
    return (
      <Container width={900}>
        <Input
            variant='filled'
            defaultValue={datesSelected?.getDate().toString()}
            onFocus={() => setDateRangeVisible(!dateRangeVisible)}
            placeholder={placeholder}
        />
        <Visible when={dateRangeVisible}>
            <Container position="absolute">
                <Calendar onChange={item => setDatesSelected(item)}/>
            </Container>
        </Visible>
      </Container>
    );
}

export {DatePicker};